export function construct(params: unknown) {

}

export function deconstruct(vertices: unknown, shapes: unknown) {

}

export function getNewVertices(shapes: unknown) {
    let result: number[] = [];
    const shapesArray = (Array.isArray(shapes) ? shapes : [shapes]) as any[];
    for (const shape of shapesArray.filter((shape: any) => shape.type !== 'text')) {
        const vertices = shape.getVerticesArray();
        for (const v of vertices) {
            result.push(v);
        }
    }
    return result;
}

export function pushVertices(shape: unknown, avertices: number[]) {
    /**
     * Функция предназначена для возможного серьёзного улучшения производительности программы,
     * когда функция @type {Function} drawShapes не использует цикл для прохода по всем фигурам,
     * а отрисовывает все вершины за один раз
     */
    const s = shape as any;
    const vertices = s.getVerticesArray();
    for (const v of vertices) {
        avertices.push(v);
    }
    return avertices;
}

export function replaceVertices(shape: unknown, vertices: number[]) {
    /**
     * Функция предназначена для возможного серьёзного улучшения производительности программы,
     * когда функция @type {Function} drawShapes не использует цикл для прохода по всем фигурам,
     * а отрисовывает все вершины за один раз
     */
    const s = shape as any;
    const id = s.id;
    const newVertices = s.getVerticesArray();

    const startIndex = id * 4;

    for (let i = 0; i < 4; i++) {
        vertices[startIndex + i] = newVertices[i];
    }
    return vertices;
}

function findIndexWithTolerance(number:number, array:number[], tolerance:number) {
    for (let i = 0; i < array.length; i++) {
        const diff = Math.abs(array[i] - number);
        if (diff <= tolerance) {
            return i;
        }
    }
    return -1; // Return -1 if the number is not found within the tolerance
}
